import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Error } from 'components';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Error
      iconName="sad_face"
      label="404"
      mainText="Sorry, we couldn’t find this page"
      buttonLabel="Return to previous page"
      handleClick={() => navigate(-2, { replace: true })}
    />
  );
}

export default NotFound;
